module.exports = __webpack_public_path__ + "static/img/1048_small.3536328.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1048_small.png
// module id = P8iL
// module chunks = 1